import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom';
import LandingHeaderComponent from '../components/Header/LandingHeaderComponent';
import Demographics from '../components/Demographics/Demographics';
import KeyFeatures from '../components/KeyFeatures/KeyFeatures';
import BossMagicSection from '../components/BossMagic/BossMagicSection';
import Footer from '../components/Footer/Footer';
import Policies from '../pages/LandingPage/Authentication/Policies/Policies';

const AppLayout = () => {



  return (
    <div>
     <Outlet />
    <Policies/>
    </div>
  )
}

export default AppLayout